<template>
  <v-menu offset-y v-model="show" allow-overflow>
    <template v-slot:activator="{ on }">
      <v-text-field
        color="primary"
        v-model="addressLine"
        v-on="on"
        :label="$i18n.t(label)"
        :loading="loading"
        :clearable="clearable"
        :rules="rules"
        autocomplete="nope"
      ></v-text-field>
    </template>
    <v-list
      elevation="0"
      v-if="addreses.length > 0 || (campuses && campuses.length > 0)"
    >
      <v-list-item
        v-for="(address, index) in addreses"
        :key="index"
        @click="select(address)"
      >
        <v-list-item-title>{{ address.addressLine }}</v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item
        v-for="(campus, index) in campuses"
        :key="index"
        @click="select(campus.address)"
      >
        <v-list-item-title>{{ campus.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { commonMixin } from "@/mixins/common";
import { doGet, doPost } from "@/store/common/module/apis";
import { Vue, Component, Watch } from "vue-property-decorator";
import _ from "lodash";

@Component({
  name: "AddressAutofill",
  props: {
    value: {
      default: false,
    },
    label: {
      default: "Address Line",
    },
    clearable: {
      default: false,
    },
    corp: {
      default: null,
    },
    rules: {
      default: () => [],
    },
  },
  mixins: [Themeable, commonMixin],
})
export default class AddressAutofill extends (Vue, Themeable) {
  address = { addressLine: null, city: null, country: null };
  addressLine = null;
  addreses = [];
  loading = false;
  show = false;
  campuses = [];

  async mounted() {
    this.onValueChange(this.value);
    await this.init(this.corp);
  }

  select(address) {
    this.addreses = [];
    if (!this.address) this.address = {};
    this.address.addressLine = address.addressLine;
    this.address.name = address.name;
    this.address.addressId = address.addressId;
    this.address.city = address.city;
    this.address.state = address.state;
    this.address.country = address.country;
    this.address.pinCode = address.pinCode;
    this.address.lat = address.lat;
    this.address.lon = address.lon;
    if (address && address.addressLine) this.addressLine = address.addressLine;
    else this.addressLine = null;
  }

  clear() {
    this.addressLine = null;
    this.address = {};
    this.addreses = [];
    this.$emit("input", {});
  }

  @Watch("value")
  onValueChange(val) {
    this.address = val;
    if (this.address && this.address.addressLine) {
      this.addressLine = this.address.addressLine;
    } else {
      this.addressLine = null;
    }
  }

  @Watch("addressLine")
  async onFilterChange(val, oldVal) {
    if (this.address == null)
      this.address = { addressLine: null, city: null, country: null };

    this.address.addressLine = val;

    if (oldVal && val && oldVal.length > val.length) {
      this.address.lat = null;
      this.address.lon = null;

      if (val.indexOf(this.address.city) == -1) {
        this.address.city = null;
        this.address.state = null;
        this.address.addressId = null;
        if (val.indexOf(this.address.country) == -1) {
          this.address.country = null;
        }
      }
    }

    if (!oldVal && this.address.lat != null && this.address.lon != null) return;

    const debounceCalculate = _.debounce(this.debounceAddresses, 300);
    debounceCalculate(val);
  }

  async debounceAddresses(val) {
    if (this.address.addressLine !== val) return;
    // console.log(val);
    this.address = _.clone(this.address);
    await this.populateAddressFromId();

    this.$emit("input", this.address);

    if (val != null && val.length > 1 && val.length < 20) {
      val = val.toLowerCase();
      this.loading = true;
      const response = await doGet("/api/o/maputil/autocomplete?key=" + val);
      if (response && response.addresses && response.addresses.length > 0) {
        this.addreses = response.addresses;
      } else {
        this.addreses = [];
      }
      this.loading = false;
      if (this.addreses != null && this.addreses.length > 0) this.show = true;
    }
  }

  async populateAddressFromId() {
    if (
      this.address.addressId &&
      (this.address.lat == null || this.address.lat == undefined)
    ) {
      try {
        const addr = await doPost(
          "/api/o/maputil/address/fromId",
          this.address
        );
        if (addr) {
          if (addr.lat != null && addr.lon != null) {
            this.address.lat = addr.lat;
            this.address.lon = addr.lon;
            this.address.addressId = null;
          }
          if (!this.address.country && addr.country != null)
            this.address.country = addr.country;
          if (!this.address.city && addr.city != null)
            this.address.city = addr.city;
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  @Watch("addresses")
  onAddressChange(val) {
    if (val == null || val.length == 0) this.show = false;
  }

  onClick() {
    this.onAddressChange(this.addreses);
  }

  async init(val) {
    if (val != null && val !== "") {
      this.filter = "";
      this.loading = true;
      this.campuses = await doGet("/api/campus/" + val + "/campus/all");
      this.loading = false;
      // this.selectValue();
    } else {
      this.campuses = [];
      this.loading = false;
    }
  }

  @Watch("corp", { immediate: true })
  async onCorpChange(val) {
    await this.init(val);
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 60px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
